import { Icon, IconType } from '@components/Icon';

import style from './Center.module.scss';

export interface CenterParams {
    text: string;
    icon?: IconType;
}

interface CenterContentProps extends CenterParams {}

export function TabCenter({ text, icon }: CenterContentProps) {
    return (
        <div className={style.root}>
            {icon !== undefined && (
                <div className={style.icon}>
                    <Icon type={icon} />
                </div>
            )}
            {text}
        </div>
    );
}
